import {
  background,
  border,
  color,
  flexbox,
  grid,
  interactivity,
  layout,
  list,
  opacity,
  position,
  scroll,
  shadow,
  space,
  transform,
  transition,
  typography,
  transformers,
} from './scales';

import {pseudoPropNames, pseudoSelectors} from './pseudos';

export const systemConfig = Object.assign(
  {
    transformers,
  },
  background,
  border,
  color,
  flexbox,
  grid,
  interactivity,
  layout,
  list,
  opacity,
  position,
  scroll,
  shadow,
  space,
  transform,
  transition,
  typography
);

export const propNames = [...Object.keys(systemConfig), ...pseudoPropNames];
const styleProps = {...systemConfig, ...pseudoSelectors};

export const isStyleProp = (prop) => prop in styleProps;
